module.exports = __webpack_public_path__ + "Poppins-SemiBold.e63b93dfac2600782654.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/poppins/Poppins-SemiBold.ttf
// module id = ../../../../../src/assets/fonts/poppins/Poppins-SemiBold.ttf
// module chunks = main